// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__cRGo4","box":"WorkspacesBox_box__zGQHd","node":"WorkspacesBox_node__3K4hR"};